/* MMM live waitlist only. No customer fields are copied from Klaviyo. */
(() => {
  if (window.__mmmWaitlistTikTok || !document.querySelector('.waitlist-landing')) return;
  window.__mmmWaitlistTikTok = true;
  const pixelId = 'DATBQ3BC77UAAGDAK1K0';
  let started = false;
  let submitted = false;

  const allowed = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(privacy && privacy.marketingAllowed() &&
      privacy.analyticsProcessingAllowed() && privacy.saleOfDataAllowed());
  };

  const start = () => {
    if (!allowed()) {
      if (started) window.ttq.revokeConsent();
      return;
    }
    if (started) {
      window.ttq.grantConsent();
      return;
    }
    started = true;
    // TikTok's standard browser loader, loaded only after Shopify permits tracking.
    !function(w,d,t){
      w.TiktokAnalyticsObject=t;
      const ttq=w[t]=w[t]||[];
      ttq.methods=['page','track','identify','instances','debug','on','off','once','ready','alias','group','enableCookie','disableCookie','holdConsent','revokeConsent','grantConsent'];
      ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)));};};
      for(let i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
      ttq.instance=function(t){const e=ttq._i[t]||[];for(let n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e;};
      ttq.load=function(e,n){
        const r='https://analytics.tiktok.com/i18n/pixel/events.js';
        ttq._i=ttq._i||{};ttq._i[e]=[];ttq._i[e]._u=r;
        ttq._t=ttq._t||{};ttq._t[e]=+new Date;
        ttq._o=ttq._o||{};ttq._o[e]=n||{};
        const script=d.createElement('script');script.type='text/javascript';script.async=true;
        script.src=r+'?sdkid='+e+'&lib='+t;d.head.appendChild(script);
      };
      ttq.disableCookie();
      ttq.load(pixelId);
      ttq.page();
    }(window,document,'ttq');
  };

  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail;
    if (!detail || detail.formId !== 'TrKEyF' || detail.type !== 'submit' || submitted || !allowed()) return;
    start();
    submitted = true;
    window.ttq.track('SubmitForm', {content_name: 'MMM Waitlist'});
  });
  document.addEventListener('visitorConsentCollected', start);
  if (window.Shopify && window.Shopify.customerPrivacy) start();
  else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
      if (!error) start();
    });
  }
})();
